import { UseFormReturn } from '@gcl/react-core';
import { EAdminUploadFileFormKey, FILE_UPLOAD_URL_FIELD_NAME } from './admin.constants';

export const uploadFileSuccessCallback = (
  response: string | undefined,
  idUseFormMethods: UseFormReturn,
  itemUseFormMethods: UseFormReturn,
) => {
  if (!response) return;
  itemUseFormMethods.setValue(`${EAdminUploadFileFormKey.FILE_CONTENT}${FILE_UPLOAD_URL_FIELD_NAME}`, response);
};
